import { defineStore } from "pinia";
import { ref } from "vue";
import { apiClient } from "@/client";
import type { FeatureDetail } from "@/type/api";

export const useFeatureStore = defineStore("feature", () => {
	const _byID = ref<Map<number, FeatureDetail>>(new Map());
	const detail = ref<FeatureDetail | null>(null);
	const loading = ref(false);
	const error = ref<string | null>(null);

	function byID(id: number): FeatureDetail | undefined {
		return _byID.value.get(id);
	}

	async function fetchByID(id: number, force = false): Promise<FeatureDetail> {
		if (!force) {
			const cached = _byID.value.get(id);
			if (cached) {
				detail.value = cached;
				return cached;
			}
		}

		loading.value = true;
		error.value = null;
		try {
			const data = await apiClient.JSONGet<FeatureDetail>(`/api/feature/${id}`);
			_byID.value.set(data.id, data);
			detail.value = data;
			return data;
		} catch (e: any) {
			error.value = e?.message ?? "Failed to load feature";
			throw e;
		} finally {
			loading.value = false;
		}
	}

	return { byID, detail, fetchByID, loading, error };
});
